import React, {Component} from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import './index.css';

import {
    getCategoriesStatistics,
    getCompanyInfoStatistics,
    getOperatorsWorksTimeData,
    getPeakHoursStatistics
} from '../../../../../services/chat/api';

import {getStatisticNumbers} from '../../../../../services/statistics/api';

import {selectConversationRequested} from "../../../../../services/chat/action";
import Statistics2 from "./Statistics2";
import {getTodayDate, getTomorrowDate} from "../../../../../utils/General";

class Statistics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            opTableFetching: false,
            activeTabId: 10,
            call: false,
            statNumbers: {
                allRequests: 0,
                todaysRequests: 0,
                answeredRequests: 0,
                unansweredRequests: 0,
                activeRequests: 0,
                forwardedRequests: 0,
            },
            companyInfoList: [],
            categoriesStatisticsData: [],
            peakHoursStatisticsData: [],
            operatorsWorkTimeData: [],
            botStatisticsData: null,
            isFetchingNumbers: false,
            isFetchingCompanyInfo: false,
            bottomModalOpen: false,
            selectedSubCompanyId: 'all',
            selectedPlatform: 'all',
            whStartDate: getTodayDate(),
            whEndDate: getTomorrowDate(),
            opTimeStartDate: null,
            opTimeEndDate: null,
        };
    }

    componentDidMount() {
        this.fetchNumbers();
        this.fetchCompanyInfo();
        this.fetchSlow();

        this.interval1 = setInterval(() => {
            if (document.visibilityState === 'visible') {
                this.fetchNumbers();
            }
        }, 30000);
    }

    componentWillUnmount() {
        clearInterval(this.interval1);
    }

    setWhStartDate = (date) => {
        const {company} = this.props;
        this.setState({whStartDate: date}, () => {
            const {whEndDate} = this.state;
            getOperatorsWorksTimeData(company.id, date, whEndDate).then(data => {
                this.setState({operatorsWorkTimeData: data});
            });
        });
    };

    setWhEndDate = (date) => {
        const {company} = this.props;
        this.setState({whEndDate: date}, () => {
            const {whStartDate} = this.state;
            getOperatorsWorksTimeData(company.id, whStartDate, date).then(data => {
                this.setState({operatorsWorkTimeData: data});
            });
        });
    };

    filterPeakHoursData = (companyIds, platform) => {
        const {company} = this.props;
        const subCompanyIds = companyIds === 'all' ? company.subs.map(sub => sub.id) : [companyIds];
        getPeakHoursStatistics(subCompanyIds, platform).then(data => {
            this.setState({peakHoursStatisticsData: data})
        });
    }

    fetchNumbers = () => {
        if (this.state.isFetchingNumbers) return;
        this.setState({
            isFetchingNumbers: true
        })

        const {company} = this.props;
        const {selectedSubCompanyId} = this.state;
        const subCompanyIds = selectedSubCompanyId === 'all' ? company.subs.map(sub => sub.id) : [selectedSubCompanyId];

        getStatisticNumbers(subCompanyIds).then(data => {
            if (data) {
                this.setState({
                    statNumbers: data
                });
            }
        }).finally(() => {
            this.setState({
                isFetchingNumbers: false
            })
        })
    };

    fetchCompanyInfo = () => {
        if (this.state.isFetchingCompanyInfo) return;
        this.setState({
            isFetchingCompanyInfo: true
        })

        getCompanyInfoStatistics(this.props.company.subs.map(sub => sub.id)).then(result => {
            this.setState({
                companyInfoList: result
            })
        }).finally(() => {
            this.setState({
                isFetchingCompanyInfo: false
            })
        });
    }

    fetchSlow = () => {
        const {company} = this.props;
        const {selectedSubCompanyId, selectedPlatform, whStartDate, whEndDate} = this.state;
        const subCompanyIds = selectedSubCompanyId === 'all' ? company.subs.map(sub => sub.id) : [selectedSubCompanyId];

        getOperatorsWorksTimeData(company.id, whStartDate, whEndDate).then(data => {
            this.setState({operatorsWorkTimeData: data});
        });

        getCategoriesStatistics(subCompanyIds, selectedPlatform).then(categories => {
            this.setState({categoriesStatisticsData: categories});
        });

        getPeakHoursStatistics(subCompanyIds, selectedPlatform).then(data => {
            this.setState({
                peakHoursStatisticsData: data,
            })
        });

    };

    setData = data => {
        this.setState({botStatisticsData: data});
    };

    render() {
        const {
            selectedPlatform,
            call,
            companyInfoList,
            categoriesStatisticsData,
            peakHoursStatisticsData,
            operatorsWorkTimeData,
            statNumbers,
            isFetchingNumbers,
            isFetchingCompanyInfo
        } = this.state;

        const {company, user} = this.props;

        return (
            <div style={{display: 'flex', flexDirection: 'column'}}>
                <Statistics2
                    call={call}
                    selectedPlatform={selectedPlatform}
                    companyInfoList={companyInfoList}
                    categoriesStatisticsData={categoriesStatisticsData}
                    statNumbers={statNumbers}
                    isFetchingNumbers={isFetchingNumbers}
                    isFetchingCompanyInfo={isFetchingCompanyInfo}
                    peakHoursStatisticsData={peakHoursStatisticsData}
                    filterPeakHoursData={this.filterPeakHoursData}
                    operatorsWorkTimeData={operatorsWorkTimeData}
                    setData={this.setData}
                    user={user}
                    company={company}
                    whStartDate={this.state.whStartDate}
                    whEndDate={this.state.whEndDate}
                    setWhStartDate={this.setWhStartDate}
                    setWhEndDate={this.setWhEndDate}

                />
            </div>
        );
    }
}

Statistics.propTypes = {
    user: PropTypes.object.isRequired,
    company: PropTypes.object.isRequired,
    selectConversation: PropTypes.func,
    commonStyles: PropTypes.shape({
        wrapper: PropTypes.object.isRequired,
        title: PropTypes.object.isRequired
    }).isRequired
};

const mapDispatchToProps = dispatch => ({
    selectConversation: conversation => dispatch(selectConversationRequested(conversation))
});

export default Radium(Statistics);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/statistics/index.jsx